import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, signal, ViewEncapsulation, WritableSignal } from "@angular/core";
import { MatListModule } from "@angular/material/list";
import { SidebarSectionComponent } from "@core/components/ui/sidebar/components/content/components/section/sidebar-section.component";
import { SidebarItem } from "@core/types/sidebar.type";

@Component({
  selector: "app-core-sidebar-content",
  templateUrl: "./sidebar-content.component.html",
  styleUrl: "sidebar-content.component.scss",
  imports: [
    MatListModule,
    SidebarSectionComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  encapsulation: ViewEncapsulation.Emulated
})
export class SidebarContentComponent {
  elementRef: ElementRef = inject(ElementRef);

  @Input({ required: true, transform: (value: SidebarItem[]): WritableSignal<SidebarItem[]> => signal(value) })
  items!: WritableSignal<SidebarItem[]>;

  /* TODO: Favorites for future */
  /* Favorites: WritableSignal<SidebarItem[]> = signal([]); */
}
